import PropTypes from "prop-types";
import typedAction from "data/util/typedAction";
import { recordIdType } from "data/util/typedefs";
import EntityName from "data/util/EntityName";
import { ACTION_CONTEXT_KEY } from "data/util/ContextedReduceStore";

const focusType = {
    entityKey: EntityName.propType.isRequired,
    recordId: recordIdType.isRequired,
    fieldKey: PropTypes.string,
    keyboardShortcuts: PropTypes.any,
    domId: PropTypes.string.isRequired,
    [ACTION_CONTEXT_KEY]: PropTypes.string.isRequired,
};

const ActiveFormActions = {
    // these aren't very good actions...
    START_RENDER: "active-form/start-render",
    RENDERED: "active-form/rendered",
    NO_FORM_TO_RENDER: "active-form/no-form-to-render",
    MOVE_FOCUS: typedAction("*active-form/move-focus", {
        recordId: recordIdType.isRequired,
        fieldKey: PropTypes.string,
        domId: PropTypes.string.isRequired,
        delta: PropTypes.number.isRequired,
        orNextEnabled: PropTypes.bool,
        [ACTION_CONTEXT_KEY]: PropTypes.string.isRequired,
    }),
    PLACE_FOCUS_AT_START: typedAction("*active-form/place-focus-at-start", {
        recordId: recordIdType.isRequired,
        [ACTION_CONTEXT_KEY]: PropTypes.string.isRequired,
    }),
    // These get dispatched on all elements, control or not
    FOCUS_ELEMENT: typedAction("*active-form/focus-element", focusType),
    BLUR_ELEMENT: typedAction("*active-form/blur-element", focusType),
    SELECT_SIDEBAR_TAB: "active-form/select-sidebar-tab",
};

export default ActiveFormActions;



// WEBPACK FOOTER //
// ./app/data/ActiveFormActions.js